import AppData from '@/mixins/appdata'

export default {
  name   : 'Translatable',
  mixins : [AppData],
  methods: {
    getTranslatedField(item, field, LangObjName = 'Lang', fallback = true, fallbackField = '') {
      return this.getLocaleTranslatedField(this.$i18n.locale, item, field, LangObjName, fallback, fallbackField)
    },

    getUserLocaleTranslatedField(item, field, LangObjName = 'Lang', fallback = true, fallbackField = '') {
      return this.getLocaleTranslatedField(this.userLocale, item, field, LangObjName, fallback, fallbackField)
    },

    getUserLocaleCatalogTranslatedField(item, field, LangObjName = 'Lang', fallback = true, fallbackField = '') {
      return this.getLocaleTranslatedField(this.userLocaleCatalog, item, field, LangObjName, fallback, fallbackField)
    },

    getLocaleTranslatedField(locale, item, field, LangObjName = 'Lang', fallback = true, fallbackField = '') {
      let retVal = item && field && item[LangObjName] && item[LangObjName][locale] && item[LangObjName][locale][field] || ''
      if (!retVal) retVal = item && field && item[LangObjName] && item[LangObjName][this.$i18n.locale] && item[LangObjName][this.$i18n.locale][field] || ''
      if (!retVal) retVal = item && field && item[LangObjName] && item[LangObjName][this.defaultLanguage.Code] && item[LangObjName][this.defaultLanguage.Code][field] || ''

      if (!retVal && fallback) {
        fallbackField = fallbackField || field
        retVal = item && fallbackField && item[fallbackField] || item && fallbackField && item[LangObjName] && item[LangObjName][this.defaultLanguage.Code] && item[LangObjName][this.defaultLanguage.Code][fallbackField] || ''
      }
      return retVal
    }
  }
}
